import React, { useContext } from "react";
import AppContext from "../context/Context";
import PeriodRoutes from "../routes/PeriodRoutes";

const PeriodLayout = () => {
  const { isFluid } = useContext(AppContext);

  return (
    <div className={isFluid ? "container-fluid" : "container"}>
      <PeriodRoutes />
    </div>
  );
};

export default PeriodLayout;
